/*
 *
 * SignUpPage reducer
 *
 */

import {
  SIGN_UP_SUCCESS,
  SIGN_UP_FAILURE,
  SIGN_UP_REQUEST,
  RESEND_VERIFICATION_REQUEST,
  RESEND_VERIFICATION_SUCCESS,
  RESEND_VERIFICATION_FAILURE,
  ACCOUNT_VERIFICATION_REQUEST,
  ACCOUNT_VERIFICATION_SUCCESS,
  ACCOUNT_VERIFICATION_FAILURE
} from './constants';

const initialState = {
  signUpSuccessful: false,
  hasAlreadyBeenTaken: false,
  email: '',
  verificationResent: false,
  emailConfirmed: null,
  verificationResultPending: false,
};

function signUpPageReducer(state = initialState, action) {
  switch (action.type) {
    case RESEND_VERIFICATION_SUCCESS:
      return {
        ...state,
        verificationResent: true,
      };

    case RESEND_VERIFICATION_REQUEST:
      return {
        ...state,
        verificationResent: false,
      };

    case RESEND_VERIFICATION_FAILURE:
      return {
        ...state,
        verificationResent: false,
      };

    case SIGN_UP_REQUEST:
      return {
        ...state,
        email: action.payload.email,
      };

    case SIGN_UP_SUCCESS:
      return {
        ...state,
        signUpSuccessful: true,
      };

    case SIGN_UP_FAILURE:
      return{
        ...state,
        hasAlreadyBeenTaken: true,
      };
    case ACCOUNT_VERIFICATION_REQUEST:
      return {
        ...state,
        verificationResultPending: true,
      };

    case ACCOUNT_VERIFICATION_SUCCESS:
      return {
        ...state,
        emailConfirmed: true,
        verificationResultPending: false,
      };

    case ACCOUNT_VERIFICATION_FAILURE:
      return {
        ...state,
        emailConfirmed: false,
        verificationResultPending: false,
      };

    default:
      return {
        ...state, 
        verificationResent: false
      };
  }
}

export default signUpPageReducer;



// WEBPACK FOOTER //
// ./src/containers/SelfSignUp/reducer.js